module.exports = __webpack_public_path__ + "static/media/file-video.09ab3364.svg";